import React from 'react';
import { Modal, Button, Typography, Spin, Space } from 'antd';
import Lib from '../Lib';

const { Text } = Typography;
const {
  EXPLORER_TX
} = require('../config');

class TXAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  async componentDidMount() {

  }

  render() {
    const wording = this.props.txStatus ? this.props.txStatus.toUpperCase() : 'OK';
    let linkToExplorer = <Spin />;
    if (this.props.txHash) {
      const txHash = this.props.txHash;
      const shortTxHash = Lib.shortHex(txHash);
      const url = EXPLORER_TX + txHash;
      linkToExplorer = (
        <Space direction='vertical' align='center'>
          <Text>{shortTxHash}</Text>
          <Button type='link' onClick={() => Lib.openUrl(url)}>VIEW ON EXPLORER</Button>
        </Space>
      );
    }

    return (
      <Modal title={'TRANSACTION'} visible={this.props.showTxPopup} centered={true} footer={[
        <Button key="back" onClick={() => this.props.onBack()}>
          {wording}
        </Button>,
      ]}>
        <div style={{ textAlign: 'center' }}>
          {linkToExplorer}
        </div>
      </Modal>
    );
  }
}

export default TXAlert;
